import { FulfilmentCentreForm } from './fulfilment-centre-form'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from '../../components/button'
import CountCard from '../../components/cards/CountCard'
import Icon from '../../components/icon'
import Dropdown from '../../components/inputs/dropdown'
import { TableComponent } from '../../components/table'
import { PageHeader } from '../../components/typography/PageHeader'
import { CountCardContainer } from '../../components/wrapper/CountCardsContainer'
import { NUMBER_OF_ITEMS_PER_PAGE } from '../../constants'
import { useModalControl } from '../../hooks/useModalControl'
import Layout from '../../layout'
import {
  useCreateFulfilmentCenterMutation,
  useGetFulfilmentCentersQuery,
} from '../../redux-toolkits/vendors/vendors.slice'
import { FulfilmentCentreRole } from '../../redux-toolkits/fulfilment-centres/fulfilmentCentres.type'
import { QueryProps } from '../../redux-toolkits/shared/shared.type'
export const FulfilmentCenterPage = () => {
  const [query, setQuery] = useState<QueryProps>({
    page: 1,
    limit: NUMBER_OF_ITEMS_PER_PAGE,
    search: undefined,
  })

  const navigate = useNavigate()

  const { data: centers, isFetching: fetchingCenters } =
    useGetFulfilmentCentersQuery({})

  const { modalOpen, modal, handleModalClose, handleModalOpen, setModalOpen } =
    useModalControl()

  const [addCenter, { isLoading: addingCenter }] =
    useCreateFulfilmentCenterMutation()

  return (
    <Layout>
      <div className="flex flex-col gap-6">
        <div className="flex w-full items-center gap-4 flex-wrap justify-between">
          <PageHeader title="Fulfilment Centers" className="!mb-0" />

          <Button
            type="button"
            label="Add fulfilment center"
            onClick={() => {
              handleModalOpen('addNewFulfilmentCenterModal')
            }}
            primary
            className="!w-fit"
          />
        </div>

        <CountCardContainer className="!my-0">
          <CountCard
            count={centers?.data?.total ?? 0}
            text="Total Fulfilment Centers"
            isCurrency={false}
            loading={fetchingCenters}
          />
        </CountCardContainer>

        <div className="w-full overflow-x-scroll">
          <TableComponent
            loading={fetchingCenters}
            headers={[
              'Fulfilment Center Name',
              'Type / Parent',
              'Domain',
              'Status',
              'Location',
              'Number of Creators',
              'Actions',
            ]}
            pageLimit={Number(query.limit)}
            isEmpty={[undefined, 0].includes(centers?.data?.docs?.length)}
            onPageChange={(p) => {
              setQuery({
                ...query,
                page: p,
              })
            }}
            rows={
              centers?.data?.docs?.map((fulfilmentCenter) => {
                return {
                  id: fulfilmentCenter._id,
                  content: [
                    <Link
                      to={`/fulfilment-center/${fulfilmentCenter._id}`}
                      key={`${fulfilmentCenter._id}-name`}
                      className="hover:underline transition-all duration-300"
                    >
                      {fulfilmentCenter.name}
                    </Link>,
                    fulfilmentCenter.role === 'PARENT'
                      ? 'Parent storefront'
                      : `Physical / ${
                          centers?.data.docs.find(
                            (centre) =>
                              centre.role === FulfilmentCentreRole.PARENT &&
                              centre.isActive !== false,
                          )?.name ?? 'Automatic'
                        }`,
                    fulfilmentCenter.domain ?? '—',
                    fulfilmentCenter.isActive === false ? 'Inactive' : 'Active',
                    fulfilmentCenter.address ?? '—',
                    fulfilmentCenter.role === 'PARENT'
                      ? '—'
                      : fulfilmentCenter.numberOfCreators ?? 0,
                    <Dropdown
                      className="text-left"
                      key={`${fulfilmentCenter._id}-controls`}
                      menuButton={
                        <Icon
                          id="ellipses"
                          height={18}
                          width={18}
                          className=""
                        />
                      }
                      menuItems={[
                        {
                          name: 'Edit',
                          value: 'edit',
                          onClick: () => {
                            navigate(
                              `/fulfilment-center/${fulfilmentCenter._id}`,
                            )
                          },
                        },
                      ]}
                    />,
                  ],
                }
              }) ?? []
            }
          />
        </div>
      </div>

      <FulfilmentCentreForm
        open={modalOpen && modal === 'addNewFulfilmentCenterModal'}
        setOpen={setModalOpen}
        onClose={handleModalClose}
        centres={centers?.data.docs ?? []}
        loading={addingCenter}
        onSave={async (payload) => {
          const response = await addCenter(payload)
          if (!response.data?.success) return false
          handleModalClose()
          return true
        }}
      />
    </Layout>
  )
}
